import React from "react";
import '../../App.css'
import AboutUsCard from "../AboutUsCard.js";



export default function AboutUs(){
    return (
        <>
        <h1 className="about-us">ABOUT US</h1>
        <AboutUsCard />
        
        </>
    
    )


}